import { render, staticRenderFns } from "./LocalizarTransportadora.vue?vue&type=template&id=423adda5&scoped=true"
import script from "./LocalizarTransportadora.vue?vue&type=script&lang=js"
export * from "./LocalizarTransportadora.vue?vue&type=script&lang=js"
import style0 from "./LocalizarTransportadora.vue?vue&type=style&index=0&id=423adda5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423adda5",
  null
  
)

export default component.exports